/**
 * Dropdown categories used to determine what is calling the Dropdown component.
 */
export const DROPDOWN_CATEGORIES = {
  AGGREGATION: 'aggregation',
  DEFAULT: null
};
